var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgEmptyReviewLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 136,
    viewBox: "0 0 185 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C4.08172 0 0.5 3.58172 0.5 8V16V124C0.5 130.627 5.87258 136 12.5 136H172.5C179.127 136 184.5 130.627 184.5 124V28C184.5 21.3726 179.127 16 172.5 16H80.5L74.7112 4.42229C73.356 1.71202 70.5859 0 67.5557 0H8.5Z",
    fill: "#E9F4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 64,
    r: 6,
    fill: "#4DA9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 64,
    r: 6,
    fill: "#4DA9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 92V92C85.6917 84.8059 99.3083 84.8059 109.5 92V92",
    stroke: "#4DA9FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmptyReviewLarge);
export default __webpack_public_path__ + "static/media/img_empty_review_large.9265596032a678260a09f15c5a05615c.svg";
export { ForwardRef as ReactComponent };